module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/star-5c9ddb80a01b039dee1960c2f5a22fb0.svg";